import React from 'react';
import Grid from '@material-ui/core/Grid';
import Hidden from '@material-ui/core/Hidden';

import sectionStyles from './index.module.css';

class DetailStaffSection extends React.Component {
	render() {
		return (
			<section className={`${sectionStyles.pageSection} section`} data-anchor="StaffSection">
				<Grid container spacing={0} className={`${sectionStyles.contentContainer} contentContainer`}>
					<Grid lg={6} xs={12} className={`${sectionStyles.contentContainer} contentContainer`} style={{ marginTop: 120 }}>
						<Grid container spacing={1} justify="center" className="articleTitleWithNumberContainerCenter">
							<Grid lg={1}>
								<div className={`${sectionStyles.articleTitleNumber} articleTitleNumber`}>
									10
                </div>
							</Grid>
							<Grid lg={7}>
								<Hidden mdDown>
									<div className="articleTitleNumberSubTitle">
										Introduction to M3
                  </div>
								</Hidden>
								<div className={`${sectionStyles.sectionTitleContainer} float-left`} style={{ marginTop: 15 }}>
									<div className={`${sectionStyles.articleBigTitle} articleBigTitle font-small`}>
										Staff Accounts
                  </div>
									<div className={`sectionTitleUnderline ul-long ul-thin`} />
									<div className={`${sectionStyles.articleTitle} articleTitle font-small`}>
										Create unlimited number of staff accounts.
                  </div>
									<p className={`${sectionStyles.generalArticle} generalArticle font-small font-narrow`} style={{ marginTop: 20 }}>
										Create login profiles for staff members and set permission levels for each person with customized levels for each feature.
										Create a separate login for Attendance Check-in.
                  </p>
								</div>
							</Grid>
						</Grid>
					</Grid>
				</Grid>
			</section>
		);
	}
}

export default DetailStaffSection;